import { render, staticRenderFns } from "./CouriersAdd.vue?vue&type=template&id=5b6c4d40&scoped=true"
import script from "./CouriersAdd.vue?vue&type=script&lang=js"
export * from "./CouriersAdd.vue?vue&type=script&lang=js"
import style0 from "./CouriersAdd.vue?vue&type=style&index=0&id=5b6c4d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6c4d40",
  null
  
)

export default component.exports